import Base from 'base/control/textbox'

export default {
  Base,
}
